import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="shopping-bag-4" maskId="round-filled-radius-1-stroke-1.5-IconShoppingBag4"><path fillRule="evenodd" clipRule="evenodd" d="M17 7H19.25C20.2165 7 21 7.7835 21 8.75V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V8.75C3 7.7835 3.7835 7 4.75 7H7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7ZM12 3.5C10.067 3.5 8.5 5.067 8.5 7H15.5C15.5 5.067 13.933 3.5 12 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag4;
